import { render, staticRenderFns } from "./NotificationMsgPopUp.vue?vue&type=template&id=5ee25e1a"
import script from "./NotificationMsgPopUp.vue?vue&type=script&lang=ts"
export * from "./NotificationMsgPopUp.vue?vue&type=script&lang=ts"
import style0 from "./NotificationMsgPopUp.vue?vue&type=style&index=0&id=5ee25e1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports